module.exports = __webpack_public_path__ + "static/fifth_user_image5-3464238ad218bc4a54cd8b9258d8f1ca.jpg";